import {
  constants,
  mediaQueryStyles,
  typographyStyles,
} from "@newsela/angelou";

const { colors } = constants;
const { mediaQuery } = mediaQueryStyles;
const { fontFamily } = typographyStyles;
const { xs, sm, md } = constants.breakpoints.BreakpointNames;

export const titleCss = [
  fontFamily.noto,
  {
    color: colors.ui.neutral[600],
    lineHeight: 1.2,
    margin: "8px 0 0",
    textAlign: "center",
    // TODO: Replace with Angelou typography when the new types are introduced.
    fontSize: "1.5rem",

    [mediaQuery.downTo(xs)]: {
      fontSize: "2rem",
      maxWidth: "600px",
    },

    [mediaQuery.downTo(sm)]: {
      fontSize: "2.5rem",
      maxWidth: "724px",
    },

    [mediaQuery.downTo(md)]: {
      maxWidth: "800px",
    },
  },
];
